import _classCallCheck from "/home/vsts/work/1/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import langmap from 'langmap';
import iso3311a2 from 'iso-3166-1-alpha-2';
var allLocales = [];

for (var code in langmap) {
  if (!langmap.hasOwnProperty(code)) continue;

  if (code.includes('-')) {
    var item = {
      locale: {
        iso_639: code.split('-')[0],
        iso_639_with_country: code,
        native_name: langmap[code].nativeName,
        english_name: langmap[code].englishName
      },
      country: {
        iso_3166_1_alpha_2: code.split('-')[1],
        english_name: iso3311a2.getCountry(code.split('-')[1])
      }
    };
    if (!item.country.english_name) continue;
    allLocales.push(item);
  }
}

var LocalesList = /*#__PURE__*/function () {
  function LocalesList() {
    _classCallCheck(this, LocalesList);
  }

  _createClass(LocalesList, null, [{
    key: "getAll",
    value: function getAll() {
      return allLocales;
    }
  }]);

  return LocalesList;
}();

export { LocalesList as default };